import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { Form } from '../../form/form';
import { InputProps } from '../../form/form-input/input/type';
import { FieldItemProps } from '../../form/types';
import './style.less';

export type SearchInputFormItemProps = Omit<FieldItemProps, 'children'> & {
  inputProps?: InputProps;
  searchIcon?: 'prefix' | 'suffix';
  onSearch?: (keyword?: string) => void;
};

/**
 * 搜索框，必须在Form中使用
 * @param props
 * @returns
 */
export const SearchInputFormItem = (props: SearchInputFormItemProps) => {
  const { inputProps, searchIcon = 'prefix', onSearch, onItemValueChange, ...otherProps } = props;
  const isPrefix = searchIcon === 'prefix';
  const iconLayout = (
    <span className={classNames('input-search-icon', isPrefix ? 'prefix-icon' : 'suffix-icon')}></span>
  );

  const onSearchHandle = hooks.useCallbackRef((keyword, all) => {
    onSearch?.(keyword as string);
    onItemValueChange?.(keyword, all);
  });

  return (
    <Form.Item
      suffix={!isPrefix ? iconLayout : undefined}
      prefix={isPrefix ? iconLayout : undefined}
      {...otherProps}
      className="v-search-input-form-item"
      onItemValueChange={onSearchHandle}
    >
      <Form.Input placeholder="搜索" {...inputProps} />
    </Form.Item>
  );
};
